import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const BurgerMenuWrapper = styled.div`
  padding-bottom: 4px;
  margin-left: 10px;
  text-align: left;
  z-index: 100;
  @media screen and (min-width: 992px) {
    margin-left: 22px;
  }
`;

export const Menu = styled.div`
  position: relative;
`;

export const StyledList = styled.ul`
  position: absolute;
  top: 8px;
  right: 0;
  list-style-type: none;
  background: #fff;
  padding: 0 0 10px;
  z-index: 1;
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  border-radius: 4px;
  width: 166px;
`;

export const StyledListItem = styled.li`
  position: relative;
  padding-left: 8px;
  &:hover{
    background: #CADFFC;
  }
`;

export const CustomLink = styled(Link)`
  color: #2C2B48;
  border-bottom: 1px solid rgba(33, 33, 33, 0.08);
  display: block;
  padding: 12px 16px 14px 8px;
  &:hover{
    color: #2C2B48;
  }
`;

export const ExternalLink = styled.a`
  color: #2C2B48;
  border-bottom: 1px solid rgba(33, 33, 33, 0.08);
  display: block;
  padding: 12px 16px 14px 8px;
  &:hover{
    color: #2C2B48;
  }
`

export const SpanClicable = styled.span`
  cursor: pointer;
  color: #2C2B48;
  border-bottom: 1px solid rgba(33, 33, 33, 0.08);
  display: block;
  padding: 12px 16px 14px 8px;
  &:hover{
    text-decoration: underline;
    color: #2C2B48;
  }

`;

export const StyledImg = styled.img`
  cursor: pointer;
`;